import Links from '../lib/links';

export type TestDriveType = (
  lang: string,
  market: string,
  dealerId: string,
  modelYear: string,
  stockNumber: string,
  vehicleId: string,
  rapidName: string,
) => string;

export const getBookTestDriveUrl: TestDriveType = (
  lang,
  market,
  dealerId,
  modelYear,
  stockNumber,
  vehicleId,
  rapidName,
) => {
  const isUsed = market.includes('us');
  const canadianConfig = {
    type: isUsed ? 'cauc' : 'ca',
    slug: isUsed ? 'uc' : 'nc',
    carcode: isUsed ? 'preownedcarcode' : 'newcarcode',
  };
  const audiUrl = 'https://www.audi.ca/';
  const testDrive = Links.testDrive.url;
  const usedVehicleBookATestDriveUrl =
    lang === 'en' ? Links?.formsUsedBookATestDrive?.en : Links?.formsUsedBookATestDrive?.fr;

  if (canadianConfig.type === 'cauc') {
    if (!usedVehicleBookATestDriveUrl) return '';
    return `${usedVehicleBookATestDriveUrl}?modelid=${rapidName}&dealer_id=49${dealerId}&modelYear=${modelYear}&stock_number=${stockNumber}&vehicleId=${vehicleId}`;
  }

  return `${audiUrl}${lang}/forms${testDrive}?modelid=${rapidName}&dealer_id=49${dealerId}&modelYear=${modelYear}&stock_number=${stockNumber}&vehicleId=${vehicleId}`.replace(
    /\s/g,
    '%20',
  );
};

const getContactDealerSource = (market: string, isAvailableNow: boolean, slug: string) => {
  const documentDefined = typeof window !== 'undefined' ? window?.document : undefined;
  const locationSearch = typeof window !== 'undefined' ? window.location.search : '';
  const source = new URLSearchParams(locationSearch).get('source') ?? undefined;
  if (documentDefined?.referrer.includes('match') || source === 'vtp-findyourmatch')
    return 'findyourmatch';
  if (market === 'ca' && !isAvailableNow) return `${slug}-in-transit`;
  return slug;
};

export type FormsUrlType = (
  lang: string,
  market: string,
  dealerId: string,
  stockNumber: string,
  vehicleId: string,
  audiCode: string,
  isAvailableNow: boolean,
  rapidName: string,
) => string;

export const getFormsUrl: FormsUrlType = (
  lang,
  market,
  dealerId,
  stockNumber,
  vehicleId,
  audiCode,
  isAvailableNow,
  rapidName,
) => {
  // if (!vehicleType) return undefined;
  const audiUrl = 'https://www.audi.ca/';
  const isUsed = market.includes('us');
  const canadianConfig = {
    type: isUsed ? 'cauc' : 'ca',
    slug: isUsed ? 'uc' : 'nc',
    carcode: isUsed ? 'preownedcarcode' : 'newcarcode',
  };
  const contactDealerSource = getContactDealerSource(market, isAvailableNow, canadianConfig.slug);
  // @ts-ignore
  const windowVisitor = typeof window !== 'undefined' ? window?.ss?.visitor : undefined;
  const mcvid = windowVisitor ? windowVisitor?.getMarketingCloudVisitorID() : undefined;
  const mcvidParam = mcvid ? `&mcvid=${mcvid}` : '';

  return `${audiUrl}${lang}/forms/contact-dealer-${canadianConfig?.slug}/?modelid=${rapidName}&dealer_id=49${dealerId}&stock_number=${stockNumber}&vehicleId=${vehicleId}&audi_code=${audiCode}&source=vtp-${contactDealerSource}${mcvidParam}`;
};
